import { createSlice } from '@reduxjs/toolkit';

const filterSlice = createSlice({
    name: 'filter',
    initialState: {
        tag: "",
        sortType: "",
        sortValue: ""
    },
    reducers: {
        setTagFilter(state, action) {
            state.tag = action.payload;
        },
        setSortParams(state, action) {
            // Si es una búsqueda, limpiamos todos los filtros primero
            if (action.payload.sortType === 'search') {
                state.tag = "";
            }
            state.sortType = action.payload.sortType;
            state.sortValue = action.payload.sortValue;
            // Si el filtro es por tag, actualizamos también el estado 'tag' para compatibilidad.
            if (action.payload.sortType === 'tag') {
                state.tag = action.payload.sortValue;
            }
        },
        clearTagFilter(state) {
            state.tag = "";
        },
        clearAllFilters(state) {
            state.tag = "";
            state.sortType = "";
            state.sortValue = "";
        },
    },
});

export const { setTagFilter, setSortParams, clearTagFilter, clearAllFilters } = filterSlice.actions;
export default filterSlice.reducer;